import React, { ReactElement, ReactNode } from 'react';
import styles from './TileSections.module.scss';

interface SectionProps {
  subtitle: string;
  children: ReactNode;
}

interface RowProps {
  label: string;
  value: string;
  valueStyle?: React.CSSProperties;
}

export const SectionContent = ({ subtitle, children }: SectionProps): ReactElement => {
  return (
    <div className={styles['text-content']}>
      <p className={styles['subtitle-content']}>{subtitle}</p>
      <div className="investoracademy-divider-line" />
      {children}
    </div>
  );
};

export const RowContent = ({ label, value, valueStyle }: RowProps): ReactElement => {
  return (
    <div className={styles['text-row-content']} style={valueStyle}>
      <p className={styles['label-text']}>{label}</p>
      <p className={styles['body-text']}>{value}</p>
    </div>
  );
};
